export default __webpack_public_path__ + "static/media/desktop-hero-image.053ba3fa.jpg";